export default function ImgPopupLayer() {

    var defaultLoadingImgSrcStr = "/assets-public/bloon/gif/loading.gif";

    var layer = $("#__img_popup_layer__tableID");
    var closeBtn = $("#__img_popup_layer__closeBtnID");
    var img = $("#__img_popup_layer__imgID");

    this.init = function () {
        closeBtn.on("click", (function () {
            this.toHide();
        }).bind(this));

        layer.on("click", (function () {
            this.toHide();
        }).bind(this));

        img.on("click", (function () {
            return false; // do not execute "layer" toHide() action
        }).bind(this));
    };

    this.toShow = function (imgSrcStr, imgAltStr) {
        img.attr("src", imgSrcStr);
        img.attr("alt", imgAltStr);
        layer.show();

    };

    this.toHide = function () {
        layer.hide();
        img.attr("src", defaultLoadingImgSrcStr);
        img.attr("alt", "");
    };

    // --------------------------------------------------
    this.init();
};